import {
  ControlProps,
  optionIs,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";

/**
 * HiddenControl renders nothing but maintains the field value in the form data.
 * Useful for internal fields like message_id that shouldn't be visible to users.
 */
const HiddenControlComponent: React.FC<ControlProps> = () => {
  // Render nothing - the value is maintained in the form data
  return null;
};

/**
 * Tester function that determines if this control should be used.
 * Matches when the UI schema has the option { control: "hidden" }
 *
 * To use this control, add the following to your UI schema:
 * {
 *   "type": "Control",
 *   "scope": "#/properties/message_id",
 *   "options": {
 *     "control": "hidden"
 *   }
 * }
 */
export const hiddenControlTester: RankedTester = rankWith(
  10, // High priority to ensure it overrides default controls
  optionIs("control", "hidden"),
);

export const HiddenControl = withJsonFormsControlProps(HiddenControlComponent);
